import classNames from "classnames";
import React, { useEffect } from "react";

interface CheckboxProps {
  autoFocus?: boolean;
  keyboardNavigationOptions?: Record<string, any>;
  className?: string;
  label?: React.ReactNode;
  checked: boolean;
  error?: boolean;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent, value: boolean) => void;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
}

export const Checkbox = ({ autoFocus, keyboardNavigationOptions = {}, className, error, label, checked, disabled, onChange, onClick }: CheckboxProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && autoFocus) {
      inputRef.current.focus();
    }
  }, []);

  return <label className={classNames("checkbox-radio-with-label", {
    "checkbox-radio-with-label-error": error,
    "checkbox-radio-with-label-disabled": disabled,
  })}>
    <input
      ref={inputRef} {...keyboardNavigationOptions}
      tabIndex={0}
      className={className}
      onChange={(e) => onChange(e, !checked)}
      onClick={onClick}
      type="checkbox"
      disabled={disabled}
      checked={checked}
    />
    {label}
  </label>
}

interface CheckboxReadonlyProps {
  checked: boolean
  label: React.ReactNode
}

export const CheckboxReadonly = ({ checked, label }: CheckboxReadonlyProps) => {
  return <div className="flex gap">
    {checked ? <i className="icon-check green" /> : <i className="icon-x red" />}
    <span style={{
      marginLeft: checked ? 0 : 4,
    }}>{label}</span>
  </div>
}